// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new_post_div {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.new_post_vertical_div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.new_post_vertical_div p {
  font-size: 16px;
  margin: 0;
}

.create_post_textarea {
  width: 100%;
  min-height: 260px;
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 14px 18px;
  font-size: 17px;
  line-height: 1.5;
  font-family: inherit;
  resize: vertical;
}

.create_post_text_input_large {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 12px 18px;
  font-size: 16px;
  line-height: 2rem;
  box-sizing: border-box;
}

.create_post_image_preview_box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.create_post_image_preview {
  max-width: 200px;
  max-height: 200px;
  border-radius: 4px;
  object-fit: cover;
}

.create_post_remove_image {
  color: var(--danger, #ff0000);
  font-size: 13px;
}

.create_post_poll_options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 5px;
}

.create_post_poll_option_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}

.create_post_poll_option_row .create_post_text_input_large {
  flex: 1 1;
}

.create_post_remove_option {
  color: var(--danger, #ff0000);
  font-size: 14px;
}

.create_post_add_option {
  color: var(--primary);
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
}

.create_post_checkbox_label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  margin-top: 5px;
}

.modal-button-div .valider {
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--primary);
  border: solid 1px var(--primary);
  color: white;
}

.modal-button-div .valider:disabled {
  background-color: rgb(0, 123, 255, 0.7);
  pointer-events: none;
}

.modal_hr_button {
  border: none;
  border-top: 1px solid var(--border);
  margin: 20px 0;
}

.pointer {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/posts/PostList/createPostModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".new_post_div {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.new_post_vertical_div {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.new_post_vertical_div p {\n  font-size: 16px;\n  margin: 0;\n}\n\n.create_post_textarea {\n  width: 100%;\n  min-height: 260px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 14px 18px;\n  font-size: 17px;\n  line-height: 1.5;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.create_post_text_input_large {\n  width: 100%;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 12px 18px;\n  font-size: 16px;\n  line-height: 2rem;\n  box-sizing: border-box;\n}\n\n.create_post_image_preview_box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.create_post_image_preview {\n  max-width: 200px;\n  max-height: 200px;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.create_post_remove_image {\n  color: var(--danger, #ff0000);\n  font-size: 13px;\n}\n\n.create_post_poll_options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 5px;\n}\n\n.create_post_poll_option_row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n}\n\n.create_post_poll_option_row .create_post_text_input_large {\n  flex: 1;\n}\n\n.create_post_remove_option {\n  color: var(--danger, #ff0000);\n  font-size: 14px;\n}\n\n.create_post_add_option {\n  color: var(--primary);\n  font-size: 13px;\n  width: fit-content;\n}\n\n.create_post_checkbox_label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  margin-top: 5px;\n}\n\n.modal-button-div .valider {\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--primary);\n  border: solid 1px var(--primary);\n  color: white;\n}\n\n.modal-button-div .valider:disabled {\n  background-color: rgb(0, 123, 255, 0.7);\n  pointer-events: none;\n}\n\n.modal_hr_button {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 20px 0;\n}\n\n.pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
